import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { DownloadService } from 'src/app/services/download-service.service';
import { formatDate } from '@angular/common';
import { ErrorManagerService } from 'src/app/services/error-manager.service';
import { MessageTitle } from '../../enums/constants';

@Component({
    selector: 'app-redownload-keys',
    templateUrl: './redownload-keys.component.html',
    styleUrls: ['./redownload-keys.component.scss'],
    standalone: false
})
export class RedownloadKeysComponent implements OnInit {
  loading: boolean = false;
  keyGenerated: string;
  downloaded: boolean = false;
  downloadConfirmed: boolean = false;
  wrongkeyerror: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RedownloadKeysComponent>,
    private userService: UserService,
    public errorManager: ErrorManagerService,
    private downloadService: DownloadService
  ) {}

  form = new FormGroup({
    privateKey: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]),
  });

  ngOnInit(): void {
    var self = this;
    self.downloaded = false;
    self.downloadConfirmed = false;
  }

  verifyKey() {
    var params = this.form.value;
    var self = this;

    if (self.form.valid) {
      this.userService.verifyKey(params).subscribe(
        (res) => {
          if (res.authorized) {
            window.location.href = '/dashboard/vault-open';
          }
        },
        (err) => {
          console.log(err);
          self.form.controls['privateKey'].setErrors({ invalid: true });
        }
      );
    }
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  downloadKey() {
    const self = this;
    const datePiece = formatDate(new Date(), 'yyyyMMddhhmm', 'en-US');
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      self.downloadService.downloadVaultKeyAsText(
        `VaultKey_${datePiece}.txt`,
        self.keyGenerated
      );
    }
    else {
      self.downloadService.downloadVaultKeyAsPdf(
        `VaultKey_${datePiece}.pdf`,
        self.keyGenerated
      );
    }
    this.downloaded = true;
  }

  checkAndSetClass(e) {
    let type = e.type;
    let target = e.target;
    let value = target.value;
    let parentElement = target.parentElement;

    if (value || type === 'focus') {
      parentElement.classList.add('inputted');
    } else {
      parentElement.classList.remove('inputted');
    }
  }

  confirmDownload() {
    var self = this;
    self.downloadConfirmed = true;
  }

  downloadNewKeys() {
    var self = this;
    var params = this.form.value;
    self.wrongkeyerror = false;
    self.loading = true;
    if (self.form.valid) {
      this.userService.generateNewKeys(params).subscribe(
        (data) => {
          self.loading = false;
          const datePiece = formatDate(new Date(), 'yyyyMMddhhmm', 'en-US');
          self.keyGenerated = data.key;
          const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
          if (isMobile) {
            self.downloadService.downloadVaultKeyAsText(
              `VaultKey_${datePiece}.txt`,
              self.keyGenerated
            );
          }
          else {
            self.downloadService.downloadVaultKeyAsPdf(
              `VaultKey_${datePiece}.pdf`,
              self.keyGenerated
            );
          }
          self.downloaded = true;
          self.form.reset();
        },
        (err) => {
          self.loading = false;
          self.wrongkeyerror = true;
          self.errorManager.showError(
            self.errorManager.getMessage(err.error),
            MessageTitle.ERROR
          );
        }
      );
    }
  }
}
